import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Feed from './pages/Feed';
import Profile from './pages/Profile';
import Points from './pages/Points';
import Watchlist from './pages/Watchlist';
import Favorites from './pages/Favorites';
import Communities from './pages/Communities';
import Navbar from './components/Navbar';
import './App.css';

function AppLayout({ children }) {
  const [feedKey, setFeedKey] = useState(0);

  const handleFollowChange = () => {
    setFeedKey(k => k + 1);
  };

  return (
    <>
      <Navbar onFollowChange={handleFollowChange} />
      {React.cloneElement(children, { key: feedKey, onFollowChange: handleFollowChange })}
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<AppLayout><Feed /></AppLayout>} />
            <Route path="/profile/:userId" element={<AppLayout><Profile /></AppLayout>} />
            <Route path="/points" element={<AppLayout><Points /></AppLayout>} />
            <Route path="/watchlist" element={<AppLayout><Watchlist /></AppLayout>} />
            <Route path="/favorites" element={<AppLayout><Favorites /></AppLayout>} />
            <Route path="/communities" element={<AppLayout><Communities /></AppLayout>} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
